import { Component, Vue } from 'vue-property-decorator';

import Single from '@/components/single/single.vue';

@Component({
    components: {
        Single,
    },
    metaInfo() {
        return {
            title: 'Summary chromosome 6 questionnaire',
        };
    },
})
export default class Summary extends Vue {

}
